"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.register = exports.registrationSuccess = exports.registrationRequest = exports.registrationReject = void 0;
/* Package Imports */
var connected_react_router_1 = require("connected-react-router");
var typesafe_actions_1 = require("typesafe-actions");
var AuthApi = __importStar(require("@app/services/api/auth"));
var utils_1 = require("@server/shared/utils");
var createAction = typesafe_actions_1.deprecated.createAction;
/* Action Creators - begin */
exports.registrationReject = createAction('@@registration/REGISTRATION_REJECT', function (resolve) { return function (error) { return resolve(error); }; });
exports.registrationRequest = createAction('@@registration/REGISTRATION_REQUEST', function (resolve) {
    return function (email, firstName, lastName) { return resolve({ email: email, firstName: firstName, lastName: lastName }); };
});
exports.registrationSuccess = createAction('@@registration/REGISTRATION_SUCCESS');
/* Action Creators - end */
/* Registration's Action Functions - begin */
// Registers/Creates a new user for Blast/Faspex
var register = function (request) {
    var company = request.company, context = request.context, email = request.email, firstName = request.firstName, lastName = request.lastName, location = request.location, password = request.password, passwordConfirmed = request.passwordConfirmed, redirectPackageId = request.redirectPackageId, title = request.title;
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var redirectParam, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dispatch(exports.registrationRequest(email, firstName, lastName));
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, AuthApi.register({
                            company: company,
                            context: context,
                            email: email,
                            firstName: firstName,
                            lastName: lastName,
                            location: location,
                            password: utils_1.Base64Util.toBase64(password),
                            passwordConfirmed: utils_1.Base64Util.toBase64(passwordConfirmed),
                            title: title
                        })];
                case 2:
                    _b.sent();
                    dispatch(exports.registrationSuccess());
                    redirectParam = !!redirectPackageId ? "?redirectTo=/dash/packages/" + redirectPackageId : "";
                    dispatch(connected_react_router_1.push({ pathname: '/login', search: redirectParam, state: { email: email, fromRegistration: true } }));
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    dispatch(exports.registrationReject('There was an error while registering your account'));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.register = register;
/* Registration's Action Functions - end */
